// ============================================================
// MinikPanel — Abonelik planları (SaaS)
//
// DİKKAT: Bu dosya kurumun MinikPanel'e ödediği ücreti tanımlar.
// Velinin kuruma ödediği okul ücretiyle karıştırılmamalı:
//
//   veli    → kurum        okul ücreti   (domain/fees.js, invoices.js)
//   kurum   → MinikPanel   abonelik      (domain/billing.js, bu dosya)
//
// İki sistem hiçbir yerde birbirine karışmaz; farklı para akışıdır.
//
// Fiyatlama kiracı seviyesindedir. Şube ve öğrenci sayısı ücreti
// etkiler ama fatura tek: müşteri kurum bir abone, şubeler onun
// kullanım hacmidir.
// ============================================================

/**
 * Modül kimlikleri, nav'daki görünüm kimlikleriyle aynıdır.
 * Bir modül planda yoksa kullanıcı rolü izin verse bile ekran açılmaz.
 */
export const PLANLAR = {
  baslangic: {
    id: "baslangic",
    label: "Başlangıç",
    aciklama: "Tek şubeli küçük kreşler için.",
    aylikTaban: 4500,
    subeBasina: 0,          // ilk şube tabana dahil
    ogrenciBasina: 110,
    yillikIndirimPct: 15,   // yıllık ödemede
    limitler: { sube: 1, ogrenci: 40, personel: 12 },
    moduller: [
      "panel", "yoklama", "rapor", "menu", "ogrenciler", "siniflar",
      "personel", "mesajlar", "odemeler", "etkinlikler", "ayarlar",
      "bugun", "odemelerim",
    ],
  },

  standart: {
    id: "standart",
    label: "Standart",
    aciklama: "Birden çok şubesi olan kurumlar; sağlık ve başvuru modülleri dahil.",
    aylikTaban: 9500,
    subeBasina: 2500,       // ilk şubeden sonrası
    ogrenciBasina: 95,
    yillikIndirimPct: 15,
    limitler: { sube: 4, ogrenci: 200, personel: 60 },
    moduller: [
      "panel", "yoklama", "rapor", "menu", "saglik", "ogrenciler", "siniflar",
      "personel", "mesajlar", "odemeler", "basvurular", "etkinlikler", "ayarlar",
      "raporlar", "bugun", "odemelerim",
    ],
  },

  kurumsal: {
    id: "kurumsal",
    label: "Kurumsal",
    aciklama: "Sınırsız şube, bordro ve masraf yönetimi dahil tüm modüller.",
    aylikTaban: 18000,
    subeBasina: 2000,
    ogrenciBasina: 75,
    yillikIndirimPct: 20,
    limitler: { sube: null, ogrenci: null, personel: null },   // null = sınırsız
    moduller: [
      "panel", "yoklama", "rapor", "menu", "saglik", "ogrenciler", "siniflar",
      "personel", "mesajlar", "odemeler", "finans", "basvurular", "etkinlikler",
      "ayarlar", "raporlar", "bugun", "odemelerim",
    ],
  },
};

export const PLAN_SIRASI = ["baslangic", "standart", "kurumsal"];

// ============================================================
// Modül → Firestore koleksiyonu haritası
//
// Plan kapısının sunucu tarafında uygulanabilmesi için, bir modülün
// hangi koleksiyonları kapsadığı bilinmelidir. firestore.rules bu
// haritadan ÜRETİLİR (scripts/gen-rules.mjs); elle düzenlenmez.
//
// Burada olmayan koleksiyon plan kapısına tabi değildir — yani her
// planda açıktır. Yeni bir modül eklerken koleksiyonlarını buraya
// yazmak zorunludur, aksi hâlde alt plandaki kiracı da erişebilir.
// ============================================================

export const MODUL_KOLEKSIYONLARI = {
  saglik: ["medications", "incidents"],
  finans: ["payroll", "staffAdvances", "expenses", "cashbox", "budgets"],
  basvurular: ["applications"],
};

/** Bir koleksiyonu açan modül; yoksa null (plan kapısı yok). */
export function koleksiyonModulu(koleksiyon) {
  for (const [modul, list] of Object.entries(MODUL_KOLEKSIYONLARI)) {
    if (list.includes(koleksiyon)) return modul;
  }
  return null;
}

/** Bir modülü kapsayan plan kimlikleri — kural üretimi için. */
export const modulPlanlari = modul =>
  PLAN_SIRASI.filter(id => PLANLAR[id].moduller.includes(modul));
